<template>
<div>

   <switch-languages></switch-languages>

   <div class="flex justify-center items-center min-h-[100vh] w-[100vw] py-[6rem] bg-[#F2F5F7]">
      <div class="flex flex-col max-w-[85vw] w-[750px]">
         <div class="flex flex-col items-center max-w-[750px] mb-3">
            <div class="flex justify-between items-center gap-5 w-full">
               <img class="mb-3 rounded-lg w-[85px] h-[85px]" src="@/assets/img/intestations/agency-transparent.png"/>
               <img class="mb-3 rounded-lg w-[85px] h-[85px]" src="@/assets/img/intestations/models-transparent.png"/>
            </div>        
         </div>
         <the-card >

            <div style="overflow: hidden">

                     <div>
                        <v-form
                           ref="change_pass"
                           v-model="valid_change_pass"
                        >  

                           <div class="max-w-[550px] mx-auto my-2">
                              <registration-title :title="$t('Cambia password')">
                              </registration-title>
                              <div>
                                 <v-text-field
                                    :rules="disable_rules ? [] : [validation_rules.required, validation_rules.email, validation_rules.email_match(email, r_email)]"
                                    :label="$t('E-mail')"
                                    outlined
                                    dense
                                    v-model="email"
                                 ></v-text-field>
                                 <v-text-field
                                    :rules="disable_rules ? [] : [validation_rules.required, validation_rules.email, validation_rules.email_match(email, r_email)]"
                                    :label="$t('Ripeti E-mail')"
                                    outlined
                                    dense
                                    v-model="r_email"
                                 ></v-text-field>
                                 <v-text-field
                                    :rules="disable_rules ? [] : [validation_rules.required, validation_rules.password, validation_rules.password_match(password, r_password)]"
                                    :label="$t('Password')"
                                    type="password"
                                    outlined
                                    dense
                                    v-model="password"
                                 ></v-text-field>
                                 <v-text-field
                                    :rules="disable_rules ? [] : [validation_rules.required, validation_rules.password_match(password, r_password)]"
                                    :label="$t('Ripeti Password')"
                                    type="password"
                                    outlined
                                    dense
                                    v-model="r_password"
                                 ></v-text-field>
                                 <div class="grid grid-cols-1 gap-[.5rem] divide-y divide-grey">
                                    <div class="pb-[1rem]">
                                       <v-btn color="primary" :loading="isLoading" dark block @click="changePass()">{{$t('Invia')}}</v-btn>
                                    </div>
                                    
                                 </div>
                                 
                                 <v-progress-linear
                                    v-if="isLoading"
                                    color="primary"
                                    indeterminate
                                 ></v-progress-linear>
                              </div>
                           </div>

                        </v-form>
                     </div>

            </div>

         </the-card>
      </div>
   </div>
</div>
</template>

<script>
// import moment from 'moment';
import SwitchLanguages from "@/components/SwitchLanguages.vue";

export default {
   name: "ChangePassword",
   components: {
      SwitchLanguages
   },
   data() {
      return {
         valid_change_pass: true,
         mostra_pass: false,

         disable_rules: true,

         email: "",
         r_email: "",
         password: "",
         r_password: "",

         hash: null,

         isLoading: false,
         error: null,

         loader: true,
      };
   },
   watch: {

   },
   methods: {
      async changePass(){
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.change_pass.validate();
         if(valid){

            this.isLoading = true;
            let body = {
               email: this.email,
               conferma_email: this.r_email,
               password: this.password,
               hash: this.hash
            }
            let res = await this.$store.dispatch("changePass",body);
            if(res.response.message == "PASSWORD_SAVED") 
               this.$router.replace("/");

            this.isLoading = false;
         }
      },
   },
   async created () {
      this.hash = this.$route.query.hash ?? null;

      if(!this.hash )
         this.$router.replace("/")
         
   },
};
</script>

<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}

.login {
   &--page {
      background-size: cover;
      background-position: bottom;
      position: relative;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;

      &:after {
         @include AfterFullContainer();
         z-index: 1;
         background: rgba($black, 0.3);
      }
   }

   &--wrapper {
      position: relative;
      z-index: 4;
      max-width: 1200px;
      width: 100%;
   }

   &--row {
      justify-content: center;
      max-width: calc(100vw + 24px);
   }

   &--col {
     display: flex;
      justify-content: center;
      align-items: center;
      &__login {
         justify-content: flex-end;
      }
      &__news {
         justify-content: flex-start;
         align-items: flex-start;
         display: flex;
         flex-direction: column;
      }
      @media screen and (max-width: 1200px) {
         justify-content: center;
         align-items: center;
      }
   }

   &--news {
      position: relative;

      width: 500px;
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      padding: 2rem;
      color: $black !important;

      border-radius: 6px;
      background: rgba(255, 255, 255, 0.65);

      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(11px);

      @include box-shadow();

      &:not(:first-child) {
         margin-top: 1rem;
      }

      .v-icon {
         position: absolute;
         top: 5px;
         right: 5px;
         opacity: 0.5;
         transition: opacity 0.3s ease;
         &:hover {
            opacity: 1;
         }
      }
   }

   &--card {
      position: relative;
      height: fit-content;
      width: 500px;
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      padding: 3.5rem;
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.65);

      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(11px);

      @include box-shadow();
   }

   &--img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      align-items: center;
      justify-content: center;

      overflow: hidden;
      border-radius: 100px;
      height: 75px;
      width: 75px;
      background: white;
      @include box-shadow();
      img {
         height: 80%;
         width: 80%;
      }
   }
}
.v-progress-linear {
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
}
</style>